export enum Role {
  Buyer = 'ROLE_BUYER',
  Creator = 'ROLE_CREATOR',
  Designer = 'ROLE_DESIGNER'
}
